module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoBd.75e1a3c3.otf";